<nz-modal [(nzVisible)]="isVisible" [nzTitle]="data?.id ? 'Edit POC' : 'Add a New POC'" [nzMaskClosable]="false"
  (nzOnCancel)="closeOnly()" [nzFooter]="modalFooter">
  <ng-container *nzModalContent>

    <!-- contact-form.component.html -->
    <form nz-form [formGroup]="contactForm">
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Name</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter the contact’s full name">
          <input nz-input formControlName="poc_name" placeholder="Enter contact name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7">Job Title</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter job title">
          <input nz-input formControlName="job_title" placeholder="Enter Job Title" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7">Region</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please select region">
          <nz-select nzShowSearch nzAllowClear nzServerSearch (nzOnSearch)="onSearchRegion($event)"
            formControlName="region" nzPlaceHolder="Select region">
            @for (region of regionList; track region.id) {
            <nz-option [nzValue]="region.id" [nzLabel]="region.name"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7">Vertical</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please select vertical">
          <nz-select nzShowSearch nzAllowClear nzServerSearch (nzOnSearch)="onSearchVertical($event)"
            formControlName="vertical" nzPlaceHolder="Select vertical">
            @for (vertical of verticalList; track vertical.id) {
            <nz-option [nzValue]="vertical.id" [nzLabel]="vertical.name"></nz-option>
            }
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Email</nz-form-label>
        <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid email">
          <input nz-input type="email" formControlName="poc_email" placeholder="Enter email" />
        </nz-form-control>
      </nz-form-item>

      <!-- <nz-form-item>
      <nz-form-label [nzSpan]="7" nzRequired>Phone</nz-form-label>
      <nz-form-control [nzSpan]="17" nzErrorTip="Please enter a valid phone number, including country code">
        <input nz-input type="tel" formControlName="poc_phone" placeholder="Enter phone number" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item> -->
      <nz-form-item>
        <nz-form-label [nzSpan]="7" nzRequired>Phone </nz-form-label>
        <nz-form-control [nzSpan]="17" class="phone-select"
          nzErrorTip="Please enter a valid phone number, including country code.">
          <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
            <ng-template #addOnBeforeTemplate>
              <nz-select nzShowSearch nzAllowClear formControlName="country_code" class="phone-select"
                nzPlaceHolder="Code">
                @for (countryCode of countryCodeList; track countryCode.id) {
                <nz-option [nzValue]="countryCode.id"
                  [nzLabel]="countryCode.code + ' (' + countryCode.country_name + ')'"></nz-option>
                }
              </nz-select>
            </ng-template>
            <input formControlName="poc_phone" id="phoneNumber" nz-input placeholder="Enter phone number" />
          </nz-input-group>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="7">LinkedIn URL</nz-form-label>
        <nz-form-control [nzSpan]="17">
          <!-- <nz-input-group nzAddOnBefore="https://">
            <input nz-input type="url" formControlName="poc_linkedin" placeholder="Enter LinkedIn URL" />
          </nz-input-group> -->

            <nz-input-group >
            <input nz-input type="url" formControlName="poc_linkedin" placeholder="Enter LinkedIn URL" />
          </nz-input-group>

        </nz-form-control>
      </nz-form-item>


    </form>

  </ng-container>


  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="closeOnly()">Cancel</button>
    <button nz-button nzType="primary" [disabled]="!contactForm.valid" (click)="save()">{{data?.id ? 'Update' :
      'Save'}}</button>
  </ng-template>

</nz-modal>